define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../store", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, store_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FInspDoc = void 0;
    class FInspDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "InspId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUploadError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspection", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FInspDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FInspection = parent;
            this.InspId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FInspection = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.InspId = (0, EntityUtil_1.toInt)(entity.InspId);
            a.InspAssetId = (0, EntityUtil_1.toInt)(entity.InspAssetId);
            a.InspStatus = (0, EntityUtil_1.toInt)(entity.InspStatus);
            a.DocType = (0, EntityUtil_1.toInt)(entity.DocType);
            a.DocName = b.DocName;
            a.DocDesc = b.DocDesc;
            a.IsUpload = (0, EntityUtil_1.toInt)(entity.IsUpload);
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FInspDoc.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "InspId", "Facility Inspection Id");
                this.validateReqNumber(validationState, "InspStatus", "Inspection Status");
                this.validateReqNumber(validationState, "DocType", "Document Type");
                this.validateReqString(validationState, "DocName", "Document Name");
                this.validateReqNumber(validationState, "IsUpload", "Is Uploaded?");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                InspId: this.InspId,
                InspAssetId: this.InspAssetId,
                InspStatus: this.InspStatus,
                DocType: this.DocType,
                DocName: this.DocName,
                DocDesc: this.DocDesc,
                IsUpload: this.IsUpload,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static openDocument(document) {
            services_1.SrmsServiceManager.Instance.Facility.getFacilityInspectionDocument(document.Id);
        }
        static uploadDocument(insp, documentType, fileName, base64File) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Uploading Document");
                if (insp.Facility.hasChanges()) {
                    store_1.StoreManager.Instance.modalStore.createInfoModal("You have unsaved changes. Please save your work before uploading a document", null);
                }
                else {
                    services_1.SrmsServiceManager.Instance.Facility.uploadFacilityInspectionDocument(insp.Id, documentType, fileName, base64File).then(d => {
                        let x = new FInspDoc(d, insp);
                        insp.FInspDoc.push(x);
                        resolve(x);
                    });
                }
            });
        }
    }
    exports.FInspDoc = FInspDoc;
    Object.defineProperty(FInspDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FInspDoc"
    });
    Object.defineProperty(FInspDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Document"
    });
    Object.defineProperty(FInspDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "InspId", "InspAssetId", "InspStatus", "DocType", "DocName", "DocDesc", "IsUpload", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser"]
    });
    Object.defineProperty(FInspDoc, "InspIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "InspAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspDoc, "InspStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "InspStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "DocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "DocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "DocNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspDoc, "DocNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "DocDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspDoc, "DocDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a description for the document"
    });
    Object.defineProperty(FInspDoc, "DocDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspDoc, "IsUploadReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspDoc, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspDoc, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspDoc, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspDoc, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "InspStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "DocDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "IsUpload", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "IsUploadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspDoc.prototype, "FInspection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspDoc.prototype, "merge", null);
});
